"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type PutTargetRequest } from "@/generated/fastapi";
import { putTarget } from "../api/putTarget";
import { targetsKeys } from "../queries/keys";

export default function useUpdateTargetMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: PutTargetRequest) => putTarget(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: targetsKeys.all });
    },
  });
}
